import React from "react";
import { IonItem, IonLabel, IonAccordion } from "@ionic/react";

export interface Props {}

const PlayingScoring: React.FC<Props> = () => {
  return (
    <IonAccordion value="PlayingScoring">
      <IonItem slot="header" color="light">
        <IonLabel>Playing & Scoring</IonLabel>
      </IonItem>
      <div className="ion-padding" slot="content">
        <ul>
          <li>Turn off your background music using the Music button</li>
          <li>
            Use the &lsquo;Next&rsquo; button to complete all 10 questions in
            the round (whilst teams record their answers in their Playbooks)
          </li>
          <li>
            If your quiz format includes a Crossword then a clue will appear at
            the end of each round (and form part of an automated cycle with the
            venue adverts)
          </li>
          <li>
            Turn on the Music icon on the app if you want to add background
            music during scoring
          </li>
          <li>
            Select &lsquo;Enter Results&rsquo;, collect the team sheets, select
            each team and tick those answers that are correct
          </li>
          <li>Select &lsquo;Submit&rsquo; to confirm the round scores</li>
          <li>
            Use the &lsquo;Next&rsquo; button to repeat each question and show
            the answer and a pie chart summarising results
          </li>
          <li>
            A Breaker Question will be presented at the end of R4 and R5 and
            also form part of the automated cycle
          </li>
          <li>
            Record each team&rsquo;s answer to the Breaker Question in the R5
            answers (Qwizard will use this to separate any tied teams at the
            end)
          </li>
          <li>Repeat the same process for all rounds in your quiz</li>
        </ul>
      </div>
    </IonAccordion>
  );
};

export default PlayingScoring;
